import { io } from "socket.io-client";

let socketInstance;

const getSocket = () => {
  if (!process.env.REACT_APP_API_URL) {
    return null;
  }

  if (!socketInstance) {
    socketInstance = io(process.env.REACT_APP_API_URL, {
      withCredentials: true,
      autoConnect: false,
    });
  }

  return socketInstance;
};

const ensureSocketConnection = () => {
  const socket = getSocket();

  if (socket && !socket.connected) {
    socket.connect();
  }

  return socket;
};

export const registerUser = (userId) => {
  const socket = ensureSocketConnection();

  if (socket && userId) {
    socket.emit("register", userId);
  }
};

export const listenToNotifications = (callback) => {
  const socket = ensureSocketConnection();

  if (!socket || typeof callback !== "function") {
    return () => {};
  }

  socket.on("notification", callback);

  return () => {
    socket.off("notification", callback);
  };
};

export const getRecentActivity = (callback) => {
  const socket = ensureSocketConnection();

  if (!socket || typeof callback !== "function") {
    return () => {};
  }

  socket.on("recent-activity", callback);

  return () => {
    socket.off("recent-activity", callback);
  };
};

export default getSocket;
